import { render, staticRenderFns } from "./LeakDataPopup.vue?vue&type=template&id=71a3c6de&scoped=true"
import script from "./LeakDataPopup.vue?vue&type=script&lang=js"
export * from "./LeakDataPopup.vue?vue&type=script&lang=js"
import style0 from "./LeakDataPopup.vue?vue&type=style&index=0&id=71a3c6de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a3c6de",
  null
  
)

export default component.exports